import { supabase } from './supabase'

// Sub-sprint A · Parte 2 — data + acciones de la Ficha 360 del cliente B2C.

export async function getFichaCliente(profileId) {
  const { data, error } = await supabase.rpc('admin_ficha_cliente', { p_profile_id: profileId })
  if (error) throw error
  return data
}

// Helper: invoca una edge function y normaliza errores (incluye el body de error de MP).
async function invoke(fn, body) {
  const { data, error } = await supabase.functions.invoke(fn, { body })
  if (error) {
    // El body de la function (400/500/502) viene en error.context; intentamos extraerlo.
    let detalle = error.message
    try { detalle = (await error.context?.json())?.error || detalle } catch { /* noop */ }
    throw new Error(detalle)
  }
  if (data && data.ok === false) throw new Error(data.error || 'Error en la acción')
  return data
}

export const refundCobro       = (b) => invoke('admin-refund-cobro', b)          // {payment_id, app, amount?, motivo, cliente_id?}
export const suscripcionAccion = (b) => invoke('admin-suscripcion-accion', b)    // {cliente_id, accion, motivo, meses?}
export const cambiarKit        = (b) => invoke('admin-cambiar-kit', b)           // {cliente_id, nuevo_kit_codigo, motivo}
export const resetSeguridad    = (b) => invoke('admin-reset-seguridad', b)       // {profile_id, motivo}

export async function aplicarDescuento({ cliente_id, tipo, valor, meses, motivo }) {
  const { data, error } = await supabase.rpc('admin_aplicar_descuento', {
    p_cliente_id: cliente_id, p_tipo: tipo, p_valor: valor, p_meses: meses, p_motivo: motivo,
  })
  if (error) throw error
  return data
}

export async function marcarTest({ profile_id, es_test, motivo }) {
  const { data, error } = await supabase.rpc('admin_marcar_test', {
    p_profile_id: profile_id, p_es_test: es_test, p_motivo: motivo,
  })
  if (error) throw error
  return data
}

// Kits activos (para el selector de "Cambiar kit")
export async function getKitsActivos() {
  const { data, error } = await supabase.from('kits').select('codigo, nombre, precio_susc').eq('activo', true).order('precio_susc')
  if (error) throw error
  return data || []
}
